import { Injectable } from '@angular/core'
import { XHRService } from '../../shared/services/xhr.service'
import { AppointmentRequest, AppointmentResponse } from './appointment.types'
import { AppointmentResponseSchema } from './appointment.model'
import { DateTime } from 'luxon'

@Injectable({
  providedIn: 'root',
})
export class AppointmentService {
  constructor(private xhr: XHRService) {}

  async getAppointmentTimes(clubCode: string, request: AppointmentRequest): Promise<AppointmentResponse> {
    try {
      const response = await this.xhr.clubRequest<AppointmentResponse>({
        url: `bff/club/${clubCode}/appointment-times`,
        method: 'POST',
        data: {
          latitude: request.latitude,
          longitude: request.longitude,
          day: DateTime.fromJSDate(request.date).toISODate() // returns 'YYYY-MM-DD'
        },
        headers: {
          'Content-Type': 'application/json'
        }
      })

      await AppointmentResponseSchema.validate(response)
      return response
    } catch (error) {
      // Handle 400 errors as "appointment not allowed for the given parameters"
      if (error?.response?.status === 400) {
        throw new Error('Appointment not allowed for the given parameters')
      }
      throw error
    }
  }
}